export default "__VITE_ASSET__B6o4MC4w__"